export default form => ({
  chars: {
    gender: '',
    characteristics: { default: '' },
    age: '',
    story: ''
  },
  bouquet: {
    shape: '',
    size: '',
    color: { default: '' },
    comments: '',
    specific_size: ''
  },
  card: {
    card_text: '',
    card: ''
  },
  delivery: {
    method: form.delivery.method.values[0],
    address: {
      given_name: '',
      family_name: '',
      company: '',
      street: '',
      house_number: '',
      postal_code: '',
      city: '',
      tel: '',
      email: ''
    },
    date: '',
    time: '',
    comments: '',
    pickup_time: '',
    specific_time: ''
  },
  payment: {
    address: {
      given_name: '',
      family_name: '',
      company: '',
      street: '',
      house_number: '',
      postal_code: '',
      city: '',
      tel: '',
      email: ''
    },
    method: ''
  },
  summary: { terms: '', newsletter: false }
})
